import { render, staticRenderFns } from "./Create-Tagging.vue?vue&type=template&id=21ee6e6c&"
import script from "./Create-Tagging.vue?vue&type=script&lang=js&"
export * from "./Create-Tagging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports